module.exports = __webpack_public_path__ + "static/media/x250d.1a737392.jpg";